/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StaffMealLedgerDto { 
    amount?: number;
    id?: number;
    merchantName?: string;
    newBalance?: number;
    orderId?: number;
    orderNo?: string;
    paymentId?: number;
    paymentNo?: string;
    previousBalance?: number;
    staffId?: number;
    staffName?: string;
    staffNo?: string;
    transactionDate?: string;
    transactionType?: string;
}

